import { SignUp } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/sign-up")({
	component: SignUpPage,
});

function SignUpPage() {
	return (
		<div className="min-h-screen bg-base-200 flex items-center justify-center p-4">
			<SignUp routing="hash" />
		</div>
	);
}
